import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DataService, ToastrService } from '../../../_services/index';
import 'rxjs/Rx';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.css'],
    providers: [ToastrService]
})
export class PasswordResetComponent implements OnInit {
    model: any = {};
    loading = false;
    usersForm: FormGroup;
    email: FormControl;
    _BTNcolor: string;
    redemptionParams: any;
    redemptionParamsStringified: string;

    constructor(private _dataService: DataService,
        private _toastrService: ToastrService,
        private activatedRoute: ActivatedRoute,) {
    }

    ngOnInit() {
        this._BTNcolor = '#333';
        this.createFormControls();
        this.createForm();
        this.activatedRoute.queryParams.subscribe(p => {
            this.redemptionParamsStringified = (p['redemptionParams'] || '');
            this.redemptionParams = JSON.parse((p['redemptionParams'] || '{}'));
        });
        (<any>window).gtag('config', environment.gaId, { 'page_path': `/password-reset` });
    }

    createFormControls() {
        this.email = new FormControl('', {
            validators: [
                Validators.required,
                Validators.pattern("[^ @]*@[^ @]*")
            ],
            updateOn: 'change'
        });
    }

    private createForm() {
        this.usersForm = new FormGroup({
            userFormDetails: new FormGroup({
                email: this.email
            })
        });
    }


    changeColor(email) {
        // const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        // const value = regex.test(email.toLowerCase());
        if (email.length > 0) {
            this._BTNcolor = '#28a745';
        } else {
            this._BTNcolor = '#333';
        }
    }


    onSubmit() {
        // console.log(this.usersForm);
        const formData = this.usersForm.controls.userFormDetails["controls"];
        formData['email'].markAsTouched(true);
    }

    passwordReset(form) {
        const formData = form.controls.userFormDetails.value;
        if (!this.usersForm.valid) {
            this.onSubmit();
            // console.log("Form is invalid!");
            return;
        }
        this.loading = true;
        const url = '/api/passwordReset';
        const body = { 'email': formData.email, 'redemptionParams': this.redemptionParamsStringified };

        this._dataService.post(url, body)
            .subscribe(
                (data: { data: any, response: string, response_message: Array<any> }) => {
                    if (data.response === 'success') {
                        // this._toastrService.typeCustomSuccess(data.response_message);
                        this._toastrService.typeCustomSuccess(`Please check your email inbox for password reset link: ${data.data}`);
                        this.model = {};
                        this.loading = false;

                        (<any>window).gtag('event', 'Click', {
                            'event_category': 'Button Clicked',
                            'event_label': `Password Reset Button by User ${formData.email}`
                        });
                    }
                },
                (error) => {
                    console.log(error);
                    this._toastrService.typeCustomError(error.error.response_message || error.status_text);
                    this.loading = false;
                });
    }
}



// WEBPACK FOOTER //
// ./public/app/modules/login/password-reset/password-reset.component.ts